import { CreateNewPayGoBtn } from './CreateNewPayGoBtn/CreateNewPayGoBtn'
import PayGoFormPresenter from './PayGoForm/PayGoFormPresenter'

export const NewPayGo = {
    NewPayGoBtn: CreateNewPayGoBtn,
    PayGoForm: PayGoFormPresenter,
}

export default NewPayGo
